import { useHookstate } from "@hookstate/core";
import Modal from "../Modal/Modal";
import DefaultButton from "../default-button/DefaultButton";
import { updateLocalStateRaw } from "../../misc/utils";
import ArrowLeft from "../../assets/icons/ArrowLeft";

export const Merits = ({ student }: { student: any }) => {
    const localState = useHookstate({});
    const state: Record<string, any> = localState.get();
    const modalOpen = Boolean(state.modalOpen);
    const merits: any[] = student.merits || [];

    const toggleModal = () => updateLocalStateRaw(localState, 'modalOpen')(!modalOpen);

    return (
        <div className="flex flex-row justify-between items-center">
            <span className="font-medium text-[32px] leading-8 text-valley-main">
                {merits.length}
            </span>
            <DefaultButton onClick={toggleModal} additionalStyle="border border-valley-light-gray px-2 py-1 text-[13px] leading-[15.6px] text-valley-gray" buttonText="Подробнее" />
            <Modal
                additionalClassName='!w-[30%] h-[35%] rounded-xl flex flex-col p-8 overflow-y-auto'
                visible={modalOpen}
                setVisible={updateLocalStateRaw(localState, 'modalOpen')}
            >
                <div className="flex flex-col flex-1 gap-8 overflow-y-auto">
                    <span className="font-normal text-2xl leading-[26.4px] text-valley-black">
                        Награды пользователя
                    </span>
                    <div className="flex flex-col overflow-y-auto flex-1">
                        {merits.map(m => (
                            <div className='flex flex-row gap-4 items-center px-4 py-2' key={m.id}>
                                <img className='w-10 h-10' src={m.media.link} alt={m.key} />
                                <span className='text-xl font-medium text-valley-black'>
                                    {m.name}
                                </span>
                            </div>
                        ))}
                    </div>
                    <DefaultButton
                        buttonText="Вернуться"
                        additionalStyle="bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
                        Icon={ArrowLeft}
                        onClick={toggleModal}
                    />
                </div>
            </Modal>
        </div>
    )
}